<template>
    <div class="news">
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="news_details">
                          <h3>{{details.title_mn}}</h3>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="social-share">
                                <ShareNetwork
                                    v-if="details.title_mn"
                                    network="facebook"
                                    :url="`https://tvets.edu.mn/news/${details.id}`"
                                    :title="details.title_mn"
                                    :description="getContent(details.des_mn)"
                                    :quote="getContent(details.des_mn)"

                                    hashtags="mergejilmn"
                                >
                                  <i class="fa fa-facebook"></i>
                                </ShareNetwork>
                                <ShareNetwork
                                    v-if="details.title_mn"
                                    network="twitter"
                                    :url="`https://tvets.edu.mn/news/${details.id}`"
                                    :title="details.title_mn"
                                    :description="getContent(details.des_mn)"
                                    :quote="getContent(details.des_mn)"

                                    hashtags="mergejilmn"
                                >
                                  <i class="fa fa-twitter"></i>
                                </ShareNetwork>
                                <ShareNetwork
                                    v-if="details.title_mn"
                                    network="linkedIn"
                                    :url="`https://tvets.edu.mn/news/${details.id}`"
                                    :title="details.title_mn"
                                    :description="getContent(details.des_mn)"
                                    :quote="getContent(details.des_mn)"

                                    hashtags="mergejilmn"
                                >
                                  <i class="fa fa-linkedin"></i>
                                </ShareNetwork>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="date">
                                <p>{{details.created_at | date}}</p>
                              </div>
                            </div>
                          </div>
                          <div class="news_image">
                              <img :src="details.thumb" alt="">
                          </div>
                          <div>
                            <p v-html="details.content_mn"></p>
                          </div>
                          <div >
                             <p v-html="details.des_mn"></p>
                          </div>
                          <br>
                          <h3>{{details.title_en}}</h3>
                          <br>
                          <div >
                              <p v-html="details.des_en"></p>
                          </div>

                        <div class="new-photos" :key="index" v-for="(photo, index) in details.photos">
                            <img :src="photo.response" alt="">
                        </div>
                        <div class="video">
                            <youtube v-if="details.video_link" :video-id="getVideo(details.video_link)" player-width="100%"  ></youtube>
                        </div>

                    </div>
                </div>
                <div class="col-md-4">
                    <div class="other">
                        <h3>мэдээ мэдээлэл</h3>
                        <div class="another-news">
                            <ul class="list-post" style="padding: 10px 0;">
                                <li class="clearfix" :key="index" v-for="(ne, index) in news">
                                    <div class="post-block-style post-float clearfix">
                                        <div class="post-thumb">
                                            <router-link :to="`/newsDetails/${ne.id}`">
                                                <img class="img-fluid" :src="ne.thumb" alt="">
                                            </router-link>
                                        </div>
                                        <div class="post-content">
                                            <h2 class="post-title title-small">
                                                <router-link  :to="`/newsDetails/${ne.id}`">
                                                   {{ne.title_mn}}
                                                </router-link>
                                            </h2>
                                            <div class="post-meta">
                                                <span class="post-date"><i class="fa fa-calendar " aria-hidden="true" style="color: #1054b1; padding-right: 5px"></i>{{ne.created_at | date}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>

<!--                                <li class="clearfix">-->
<!--                                    <div class="post-block-style post-float clearfix">-->
<!--                                        <div class="post-thumb">-->
<!--                                            <router-link to="">-->
<!--                                                <img class="img-fluid" src="../../assets/niigem.png" alt="">-->
<!--                                            </router-link>-->
<!--                                        </div>-->
<!--                                        <div class="post-content">-->
<!--                                            <h2 class="post-title title-small">-->
<!--                                                <router-link to="">-->
<!--                                                    Энэ онд 60 цэцэрлэг, 35 сургууль ашиглалтад оруулна-->
<!--                                                </router-link>-->
<!--                                            </h2>-->
<!--                                            <div class="post-meta">-->
<!--                                                <span class="post-date"><i class="fa fa-calendar " aria-hidden="true" style="color: #1873cc; padding-right: 5px"></i>2020/10/01</span>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </li>-->

                            </ul>
                        </div>
                        <div class="video">
                            <youtube v-if="vedio.video_link" :video-id="getVideo(vedio.video_link)" player-width="100%"  player-height="295"></youtube>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getIdFromURL} from 'vue-youtube-embed';
    import { getNewsDetails, getNews} from "../../api/index"
    export default {

        components: {

        },
        data () {
            return {
                videoId: 'ePN0jzFsEb0',
                getVideo: getIdFromURL,
                details: {},
                news: [],
                photos: [],
                vedio: {},

            }
        },
        mounted () {
            this.calldata();
            this.vedio = window.init.news;
        },
        methods: {
            getContent(desc){
              return desc.replace(/<[^>]*>?/gm, '')
            },
            calldata(){
                this.$isLoading(true);
                getNewsDetails(this.$route.params.id).then(response=>{
                    this.details = response.data[0];
                    this.details.photos = JSON.parse(this.details.photos);
                    console.log(response.data);
                    this.$isLoading(false);
                }).catch(error => {
                    this.$Loading.error();
                    console.log('ErrorL ', error);
                });
                getNews(this.current_page).then(response=>{
                    this.news = response.data.data;
                     this.$isLoading(false);
                }).catch(error => {
                    this.$Loading.error();
                    console.log('ErrorL ', error);
                });

            },
        },
    }
</script>
